// extracted by mini-css-extract-plugin
export var headerCell = "_1k-1";
export var loadingStateCell = "_1k-4";
export var rowWrapper = "_1k-3";
export var standaloneTable = "_1k-5";
export var table = "_1k-0";
export var white = "_1k-2";